import map from 'lodash/map'
import * as React from 'react'
// CComponents
import {Button} from '@frontrow/console/src/components/button'
import Input from '@frontrow/console/src/entities/components/base/input'

// Styles
import * as style from '../../school-admin-form/school-admin-form.module.scss'

// Components'
import FormField from '@frontrow/console/src/components/common/form-field'
import ErrorAlert from '@frontrow/console/src/components/common/error-alert'

type Props = {
  onCancel: () => void
  onSubmit: (addSchoolIds: Array<number>, deleteSchoolIds: Array<number>) => void
}

function SchoolAdminsSchoolsForm(props: Props): React.ReactElement {
  const {onCancel, onSubmit} = props
  const [addSchoolIds, setAddSchoolIds] = React.useState<string>('')
  const [deleteSchoolIds, setDeleteSchoolIds] = React.useState<string>('')
  const [formatError, setFormatError] = React.useState<string | undefined | null>(null)

  const handleSubmit = (e: React.FormEvent) => {
    const commaSeparatedListCheck = /^(|\d+(,\d+)*)$/

    const splitAndParseInt = (ids: string) =>
      ids === '' ? [] : map(ids.split(','), id => parseInt(id, 10))

    e.preventDefault()

    if (
      commaSeparatedListCheck.test(addSchoolIds) &&
      commaSeparatedListCheck.test(deleteSchoolIds)
    ) {
      onSubmit(splitAndParseInt(addSchoolIds), splitAndParseInt(deleteSchoolIds))
    } else {
      setFormatError(
        'Format of input does not follow comma separated list with no space (ie. 1,2,3,4). Try again and resubmit.'
      )
    }
  }

  const createSchoolsOnChange = (field: 'addSchoolIds' | 'deleteSchoolIds') => (val: string) => {
    if (field === 'addSchoolIds') {
      setAddSchoolIds(val)
    } else {
      setDeleteSchoolIds(val)
    }
  }

  const errorNode =
    formatError !== null && formatError !== undefined ? (
      <ErrorAlert>{formatError}</ErrorAlert>
    ) : null

  return (
    <form onSubmit={handleSubmit} action="">
      <div className={style.schoolAdminFormContainer}>
        {errorNode}
        <FormField wrapperStyle={style.schoolAdminGenericFieldContainer} label="Add Schools By Id">
          <Input
            value={addSchoolIds}
            type="text"
            placeholder={'Schools will not be added if empty'}
            onChange={createSchoolsOnChange('addSchoolIds')}
          />
        </FormField>
        <FormField
          wrapperStyle={style.schoolAdminGenericFieldContainer}
          label="Delete Schools By Id"
        >
          <Input
            value={deleteSchoolIds}
            type="text"
            placeholder={'Schools will not be deleted if empty'}
            onChange={createSchoolsOnChange('deleteSchoolIds')}
          />
        </FormField>
      </div>
      <div className={style.schoolAdminFormButtonContainer}>
        <Button style="secondary" addClass={style.schoolAdminFormCancel} onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit">Update School Admin</Button>
      </div>
    </form>
  )
}

export default SchoolAdminsSchoolsForm
